import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';

export interface InfoDialogProps {
    onClose: () => void;
    open: boolean;
    title: string;
    text: string;
}
export default function InfoDialog(props: InfoDialogProps, ref: any) {
    const { onClose, open, title, text } = props;
    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={() => { handleClose() }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {text}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => { handleClose() }}>{'OK'}</Button>
            </DialogActions>
        </Dialog>);
}